exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.vs-slider .vs-slider__tooltip,\r\n.vs-slider .vs-slider__text,\r\n.vs-slider .vs-slider__value {\n  display: none !important;\n}\n.vs-con-tbody {\n  border: none !important;\n}\n.vs-slider--circles.isEndValue {\n  border-radius: 50%!important;\n}\r\n", ""]);

// exports
